export { SetSecurityQuestionsComponent } from './set-security-questions.component';
export { SecurityQuestionAnswerComponent } from './security-question-answer/security-question-answer.component';
